var ThirdPartyAdapter = /** @class */ (function () {
    function ThirdPartyAdapter(locale) {
        this.locale = locale;
    }
    ThirdPartyAdapter.prototype.toEssResult = function (predictionDescription, placeId, index) {
        var displayName = predictionDescription;
        var primaryDisplayName = '';
        var secondaryDisplayName = '';
        var parts = (displayName || '').split(',');
        if (parts.length < 2) {
            primaryDisplayName = parts[0].trim();
        }
        else {
            primaryDisplayName = parts[0];
            secondaryDisplayName = parts
                .slice(1)
                .map(function (word) { return word.trim(); })
                .join(', ')
                .trim();
        }
        return {
            category: this.category,
            coordinates: undefined,
            index: index,
            regionNames: {
                displayName: displayName,
                fullName: predictionDescription,
                lastSearchName: predictionDescription,
                primaryDisplayName: primaryDisplayName,
                secondaryDisplayName: secondaryDisplayName
            },
            sourceId: placeId,
            sourceName: this.sourceName,
            type: this.type
        };
    };
    return ThirdPartyAdapter;
}());

export { ThirdPartyAdapter };
